<script lang="ts">
  import { DateModel, PermitPayPreviewModel, PriceModel } from "$models";
  import { BodyText, Header } from "$components";
  type Props = {
    payPreview: PermitPayPreviewModel;
  };
  const { payPreview }: Props = $props();
</script>

<Header size="4" light>Att betala idag</Header>
<table class="outset">
  <thead>
    <tr>
      <th>Artikel</th>
      <th>Antal</th>
      <th>Pris</th>
    </tr>
  </thead>
  <tbody>
    {#each payPreview.articles as article}
      {@const price = new PriceModel(article.periodPrice)}
      <tr>
        <td>{article.name}</td>
        <td class="pr-2">{article.quantity.toLocaleString()} st</td>
        <td class="whitespace-nowrap">{price.format(true)} kr</td>
      </tr>
    {/each}
    <tr>
      <td><strong>Totalt</strong></td>
      <td class="mr-2"></td>
      <td class="whitespace-nowrap">
        <strong>{payPreview.getTotalPrice().format(true)} kr</strong>
      </td>
    </tr>
  </tbody>
</table>

{#if payPreview.recurring?.nextDebitAt}
  {@const recurringStart = new DateModel(payPreview.recurring.nextDebitAt)}
  <BodyText size="s">
    från och med {recurringStart.format("D MMM YYYY")} kommer du betala {
      payPreview.recurring.price.format()
    }kr / {payPreview.recurring.period.format({ implicitMultiplier: true })}.
  </BodyText>
{/if}
